import { format } from 'date-fns';
import type PikadayType from 'pikaday';
import * as React from 'react';
import Checkbox from '../Checkbox/Checkbox';
import { Icon } from '../Icon/Icon';
import { FilterItem } from './Types';

declare let Pikaday: typeof PikadayType;

export interface ISearchFilterProp {
    searchtext: string;
    datefrom: string;
    dateto: string;
    clearfilter: () => void;
    selectedfilters: number[];
    addfilter: (filterId) => void;
    removefilter: (filterId) => void;
    onupdate: (data) => void;
    region: string;
    className?: string | undefined;
}

interface ISearchFilterState {
    selectedfilters: number[];
    searchtext: string;
    datefrom: string;
    dateto: string;
    menuOpen?: boolean;
    dropdownopen?: boolean;
}

export class SearchFilter extends React.Component<ISearchFilterProp, ISearchFilterState> {
    static GetFilterById(id: number): FilterItem {
        const filters = SearchFilter.filterItems;
        const index = filters.findIndex((x) => x.id === id);

        return SearchFilter.filterItems[index];
    }

    private static filterItems: FilterItem[] = [
        new FilterItem(0, 'Nyheter', ['NewsArticlePage']),
        new FilterItem(1, 'Områdessidor', ['LandingPage']),
        new FilterItem(2, 'Trafikkameror', ['CameraPage', 'CameraAreaPage']),
        new FilterItem(3, 'Trafikinformationsskyltar', ['VmsPage'], ['GBG']),
        new FilterItem(4, 'Trafikmeddelanden', ['SituationSearchModel']),
        new FilterItem(6, 'Trafikanordningsplaner', ['TAPlanSearchModel'], ['GBG']),
        new FilterItem(5, 'Övriga sidor', ['PagePage']),
    ];

    private defaultFilter = {
        selectedfilters: [],
        searchtext: '',
        datefrom: '',
        dateto: '',
    };

    constructor(props: ISearchFilterProp) {
        super(props);
        this.state = this.defaultFilter;
    }

    componentDidMount(): void {
        new Pikaday({
            field: document.getElementById('dateto'),
            firstDay: 1,
            i18n: {
                previousMonth: 'Förra månaden',
                nextMonth: 'Nästa månad',
                months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
                weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
                weekdaysShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
            },
            onSelect: (date) => {
                const data = { dateto: format(date, 'yyyy-MM-dd') };
                this.props.onupdate(data);
            },
        });

        new Pikaday({
            field: document.getElementById('datefrom'),
            firstDay: 1,
            i18n: {
                previousMonth: 'Förra månaden',
                nextMonth: 'Nästa månad',
                months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
                weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
                weekdaysShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
            },
            onSelect: (date) => {
                const data = { datefrom: format(date, 'yyyy-MM-dd') };
                this.props.onupdate(data);
            },
        });
    }

    render(): JSX.Element {
        const menuButtonText = this.state.menuOpen ? 'Dölj urval' : 'Visa urval';
        const menuButtonClass = this.state.menuOpen ? '' : ' show-arrow-down';
        const filtersContent = SearchFilter.filterItems.map(this.renderfilterItem.bind(this));

        return (
            <div className={this.props.className}>
                <button
                    type="button"
                    className={`btn btn-dark btn-filter d-md-none ${menuButtonClass}`}
                    aria-expanded="false"
                    aria-controls="filter-choices"
                    data-bs-toggle="collapse"
                    data-bs-target="#filter-choices"
                    onClick={this.toggleMenu}
                >
                    {menuButtonText}
                </button>
                <div id="filter-choices" className="collapse d-md-block mt-4 mt-md-0">
                    <form className="search-info__filter" onSubmit={this.handleSubmit}>
                        <div className="input-group search-info__search mb-4">
                            <div className="input-group-text">
                                <Icon symbol="icon-search" />
                            </div>
                            <input
                                className="form-control"
                                type="search"
                                placeholder="Fritextsökning"
                                name="searchtext"
                                value={this.props.searchtext}
                                onChange={this.handleUpdate}
                            />
                        </div>
                        <div className="search-info__heading">Ändra urval</div>
                        <div className="search-info__filter-list">
                            <div>
                                <ul>{filtersContent}</ul>
                            </div>
                            <hr className="search-info__filter_divider" />
                            <div className="search-info__date">
                                <div className="search-info__heading search-info__date-heading">Datumintervall:</div>
                                <div className="row">
                                    <div className="col search-info__date-left">
                                        <input
                                            className="form-control"
                                            id="datefrom"
                                            name="datefrom"
                                            type="text"
                                            placeholder="ÅÅÅÅ-MM-DD"
                                            value={this.props.datefrom}
                                            onChange={this.handleUpdate}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="col  search-info__date-right">
                                        <input
                                            className="form-control"
                                            type="text"
                                            id="dateto"
                                            name="dateto"
                                            placeholder="ÅÅÅÅ-MM-DD"
                                            value={this.props.dateto}
                                            onChange={this.handleUpdate}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="search-info__small-info">(Visar resultat som är aktiva vid valt datum)</div>
                            </div>
                            <hr className="search-info__filter_divider" />
                            <button type="button" className="btn btn-dark search-info__cancel" onClick={this.props.clearfilter}>
                                <i className="icon-cancel" aria-hidden="true" />
                                Återställ standardval
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    private handleSubmit(e) {
        e.preventDefault();
    }

    private handleChangedFilter(event, filter) {
        const checked = event.target.checked;

        if (checked) {
            this.props.addfilter(filter.id);
        } else {
            this.props.removefilter(filter.id);
        }
    }

    private toggleMenu = () => {
        this.setState({ menuOpen: !this.state.menuOpen });
    };

    private renderfilterItem(filter: FilterItem, index: number): JSX.Element {
        if (filter.hiddenregions.indexOf(this.props.region.toUpperCase()) !== -1) {
            return null;
        }

        const id = 'filter_item_' + index + '_' + filter.id;
        const isChecked =
            this.props.selectedfilters.filter((item: number) => {
                if (item === filter.id) {
                    return true;
                }

                return false;
            }).length > 0;
        const currentFilter = filter;
        const handleChange = (event) => {
            this.handleChangedFilter(event, currentFilter);
        };
        const itemClass = index > 0 ? 'mt-3' : '';

        return (
            <li key={`${index}${filter.id}_major`} className={itemClass}>
                <Checkbox name={id} label={filter.name} onChange={handleChange} checked={isChecked} />
            </li>
        );
    }

    private handleUpdate = (event) => {
        const data = {};
        data[event.target.name] = event.target.value;
        this.props.onupdate(data);
    };
}
